<div class="contenedor-tabla">
    <mat-table
        class="supervisores"
        #table
        [dataSource]="dataSource"
        [@animateStagger]="{ value: '50' }"
        fusePerfectScrollbar
    >
        <!-- Type Column -->
        <ng-container matColumnDef="rut">
            <mat-header-cell *matHeaderCellDef>Rut</mat-header-cell>
            <mat-cell *matCellDef="let supervisor">
                {{ supervisor.rut }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nombres">
            <mat-header-cell *matHeaderCellDef>Nombres</mat-header-cell>
            <mat-cell *matCellDef="let supervisor">
                {{ supervisor.nombres }}
            </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="apellidos">
            <mat-header-cell *matHeaderCellDef>Apellidos</mat-header-cell>
            <mat-cell *matCellDef="let supervisor">
                {{ supervisor.apellidos }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef
                >Correo electrónico</mat-header-cell
            >
            <mat-cell *matCellDef="let supervisor">
                {{ supervisor.email }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="acciones">
            <mat-header-cell *matHeaderCellDef>Acciones</mat-header-cell>
            <mat-cell *matCellDef="let supervisor">
                <button
                    *ngIf="superSupervisor"
                    mat-icon-button
                    title="Eliminar supervisor"
                    type="button"
                    color="accent"
                    (click)="borrar(supervisor)"
                >
                    <mat-icon>delete</mat-icon>
                </button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let supervisor; columns: displayedColumns">
        </mat-row>
    </mat-table>
</div>
